import { memo, useMemo } from "react";

import { getUnitsOfMeasureAPI } from "services/api/finance/lookups/api";
import { DropdownCacheKey, useDropdownCache } from "services/hooks/useDropdownCache";

import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

import { UnitOfMeasureDropdownProps } from "./types";

const THIRTY_MINUTES = 30 * 60 * 1000;

/** Jedinica mjere stavke — ulazi u UBL (`unitCode`) na eRačunu. */
const UnitOfMeasureDropdown: React.FC<UnitOfMeasureDropdownProps> = (props) => {
  const { name, value, onChange, label, placeholder = "Jedinica mjere", error, disabled, required, cssClassName } = props;

  const { data } = useDropdownCache(
    DropdownCacheKey.UnitsOfMeasure,
    getUnitsOfMeasureAPI,
    THIRTY_MINUTES
  );

  const options: DropdownOption[] = useMemo(
    () => (data ?? []).map((unit: any) => ({
      text: `${unit.name} (${unit.symbol})`,
      value: unit.id,
    })),
    [data]
  );

  return (
    <Dropdown
      name={name}
      value={value}
      options={options}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      error={error}
      disabled={disabled}
      required={required}
      cssClassName={cssClassName}
    />
  );
};

export default memo(UnitOfMeasureDropdown);
